import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TagsApi } from '@app/tags/tag-api.model';
import { LDFlagsService } from '@dg/shared-services';

@Component({
  selector: 'dgx-profile-skill-suggestions',
  templateUrl: './profile-skill-suggestions.component.html',
  styleUrls: ['./profile-skill-suggestions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSkillSuggestionsComponent implements OnInit {
  @Input() public isSuggestedTagsLoading: boolean = false;
  @Input() public suggestedTags: TagsApi.Tag[] = [];
  @Input() public tags: TagsApi.Tag[] = [];
  @Output() public onAddSuggestedTag = new EventEmitter<TagsApi.Tag>();

  public isSkillSuggestionsOpen = true;

  constructor(private ldFlagsService: LDFlagsService) {}

  ngOnInit(): void {}

  public get canViewSkillSuggestions(): boolean {
    return this.ldFlagsService.showProfileOverviewSkillSuggestions;
  }

  public toggleSkillSuggestionsOpen(): void {
    this.isSkillSuggestionsOpen = this.isSkillSuggestionsOpen ? false : true;
  }

  public handleAddSuggestedTag(tag: TagsApi.Tag): void {
    this.onAddSuggestedTag.emit(tag);
  }
}
